import { create } from "zustand";

export const useProgressStore = create((set) => ({
  selectedPaper: null,
  setSelectedPaper: (paper) => set({ selectedPaper: paper }),
  selectedSubject: { id: "All", weightage: 0 },
  setSelectedSubject: (subject) => set({ selectedSubject: subject }),
  showCompleted: true,
  setShowCompleted: (value) => set({ showCompleted: value }),
  openFilter: false,
  setOpenFilter: (value) => set({ openFilter: value }),
  openCard: false,
  setOpenCard: (value) => set({ openCard: value }),
  openSchedule: false,
  setOpenSchedule: (value) => set({ openSchedule: value }),
  openScheduleDate: false,
  setOpenScheduleDate: (value) => set({ openScheduleDate: value }),
  openSubjectDropdown: false,
  setOpenSubjectDropdown: (value) => set({ openSubjectDropdown: value }),
  filteredChapters: [],

  setFilteredChapters: (data, selectedPaper, selectedSubject, showCompleted) => {
    if (!data) return;
    const filterPaper = data?.data?.chapters?.filter((chapter) => chapter?.paper === selectedPaper?.name) || [];

    const filterChapters = filterPaper.filter((chapter) =>
      selectedSubject?.id !== "All" ? chapter?.subjectId === selectedSubject?.subjectId : true
    );

    const finalChapters = showCompleted
      ? filterChapters
      : filterChapters.filter(
        (chapter) =>
          !(data?.data?.progress?.progress?.chapters[chapter?.id]?.completed?.status === true)
      );
    console.log("final", finalChapters)
    console.log(data?.data?.progress?.progress)
    set({ filteredChapters: finalChapters });
  },
}));
